function TooltipOverlay(map) {
    this.map_ = map
    this.div_ = null
    this.setMap(map)
}

TooltipOverlay.prototype = new google.maps.OverlayView()

TooltipOverlay.prototype.onAdd = function() {
    var tooltip = document.createElement('DIV')
    tooltip.id = 'map_tooltip'
    tooltip.className = 'tooltip'
    this.div_ = tooltip

    var panes = this.getPanes()
    panes.floatPane.appendChild(tooltip)
}

TooltipOverlay.prototype.draw = function() {}

export default TooltipOverlay
